import React, { useContext, useEffect, useMemo, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { Link, useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import { Icon } from "@iconify/react/dist/iconify.js";
import Utils from "../utils/Utils";

const HomePageOne = () => {
  const navigate = useNavigate();
  const {
    recentEnquiries,
    tokenData,
    enquiriesHistory,
    todayEnquiries,
    upComingHolidays,
    upcomingEnquiries,
  } = useContext(AppContext);
  const [pending, setPending] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  const isExpiredRequest = (data) => {
    if (data?.status === "Expired") return true;
    // getnewrequests returns bookingTime as "YYYY-MM-DD HH:mm:ss"
    const bookingAt = data?.bookingTime || data?.bookingDate;
    if (!bookingAt) return false;
    const booked = new Date(String(bookingAt).replace(" ", "T"));
    if (Number.isNaN(booked.getTime())) return false;
    return booked < new Date();
  };

  useEffect(() => {
    const pendings =
      Array.isArray(recentEnquiries?.enquiries) &&
      recentEnquiries.enquiries.length > 0
        ? recentEnquiries.enquiries
            .filter(
              (data) =>
                data?.status === "Requested" && !isExpiredRequest(data)
            )
            .reverse()
        : [];

    setPending(pendings);
  }, [recentEnquiries]);

  const shopName = useMemo(() => {
    return (
      tokenData?.shopName ||
      window.sessionStorage.getItem("shopName") ||
      "your shop"
    );
  }, [tokenData]);

  const holidayPreview = Array.isArray(upComingHolidays)
    ? upComingHolidays.slice(0, 4)
    : [];

  const pendingPreview = Array.isArray(pending) ? pending.slice(0, 5) : [];

  const stats = [
    {
      key: "today",
      label: "Today's reservations",
      value: todayEnquiries?.length ?? 0,
      hint: "Bookings scheduled for today",
      icon: "ic:outline-today",
      tone: "primary",
      onClick: () => navigate("/table-enquiry-list"),
    },
    {
      key: "pending",
      label: "Pending requests",
      value: pending?.length ?? 0,
      hint: "Awaiting confirmation",
      icon: "ic:baseline-edit-calendar",
      tone: "warning",
      onClick: () => navigate("/table-enquiry-list?tab=1"),
    },
    {
      key: "upcoming",
      label: "Upcoming reservations",
      value: upcomingEnquiries?.length ?? 0,
      hint: "Future confirmed bookings",
      icon: "mdi:calendar-arrow-right",
      tone: "primary",
      onClick: () => navigate("/table-enquiry-list"),
    },
    {
      key: "past",
      label: "Past enquiries",
      value: enquiriesHistory?.length ?? 0,
      hint: "Completed reservation history",
      icon: "bxs:time",
      tone: "neutral",
      onClick: () => navigate("/table-enquiry-list?tab=4"),
    },
  ];

  const quickActions = [
    {
      to: "/add-reservation",
      label: "Book table",
      icon: "mdi:table-plus",
    },
    {
      to: "/table-enquiry-list",
      label: "View enquiries",
      icon: "material-symbols:table-bar-outline",
    },
    {
      to: "/promotion-list",
      label: "Promotions",
      icon: "mdi:tag-multiple-outline",
    },
    {
      to: "/events",
      label: "Events",
      icon: "mdi:calendar-month-outline",
    },
    {
      to: "/reservation-settings",
      label: "Settings",
      icon: "mdi:cog-outline",
    },
  ];

  return (
    <MasterLayout>
      <div className="home-dash">
        <header className="home-dash__hero">
          <div className="home-dash__hero-copy">
            <p className="home-dash__eyebrow">Overview</p>
            <h1 className="home-dash__title">Dashboard</h1>
            {/* <p className="home-dash__subtitle">
              Welcome back{shopName ? `, ${shopName}` : ""}. Track today’s
              bookings, pending requests, and upcoming holidays.
            </p> */}
          </div>
          <div className="home-dash__hero-actions">
            <Link to="/add-reservation" className="home-dash__btn home-dash__btn--primary">
              <Icon icon="mdi:plus" />
              <span>New reservation</span>
            </Link>
            <Link
              to="/table-enquiry-list?tab=1"
              className="home-dash__btn home-dash__btn--ghost"
            >
              <Icon icon="mdi:clock-outline" />
              <span>Review pending</span>
            </Link>
          </div>
        </header>

        {showAlert && (
          <div className="alert alert-danger text-center" role="alert">
            Domain URL is not available!
          </div>
        )}

        <section className="home-dash__stats" aria-label="Reservation stats">
          {stats.map((stat) => (
            <button
              key={stat.key}
              type="button"
              className={`home-dash__stat home-dash__stat--${stat.tone}`}
              onClick={stat.onClick}
            >
              <span className="home-dash__stat-icon" aria-hidden="true">
                <Icon icon={stat.icon} />
              </span>
              <span className="home-dash__stat-body">
                <span className="home-dash__stat-label">{stat.label}</span>
                <strong className="home-dash__stat-value">{stat.value}</strong>
                {/* <span className="home-dash__stat-hint">{stat.hint}</span> */}
              </span>
            </button>
          ))}
        </section>

        {/* <section className="home-dash__quick" aria-label="Quick actions">
          {quickActions.map((action) => (
            <Link key={action.to} to={action.to} className="home-dash__quick-item">
              <span className="home-dash__quick-icon">
                <Icon icon={action.icon} />
              </span>
              <span>{action.label}</span>
            </Link>
          ))}
        </section> */}

        <div className="home-dash__grid">
          <section className="home-dash__panel">
            <div className="home-dash__panel-head">
              <div>
                <h2 className="home-dash__panel-title">Pending requests</h2>
                <p className="home-dash__panel-desc">
                  Newest reservation requests waiting for action
                </p>
              </div>
              <Link to="/table-enquiry-list?tab=1" className="home-dash__link">
                View all
                <Icon icon="mdi:arrow-right" />
              </Link>
            </div>

            {pendingPreview.length > 0 ? (
              <ul className="home-dash__list">
                {pendingPreview.map((item, index) => (
                  <li key={item?.id ?? index}>
                    <button
                      type="button"
                      className="home-dash__list-item"
                      onClick={() =>
                        navigate(
                          item?.id
                            ? `/view-reservation/${item.id}`
                            : "/table-enquiry-list?tab=1"
                        )
                      }
                    >
                      <span className="home-dash__list-avatar">
                        {(item?.name || "G").charAt(0).toUpperCase()}
                      </span>
                      <span className="home-dash__list-meta">
                        <strong>{item?.name || "Guest"}</strong>
                        <span>
                          {item?.bookingTime
                            ? Utils.parseAndFormat2(item.bookingTime)
                            : item?.bookingDate
                              ? Utils.formatDate(item.bookingDate)
                              : "Date N/A"}
                          {item?.chairs ? ` · ${item.chairs} guests` : ""}
                        </span>
                      </span>
                      <span className="home-dash__badge">Requested</span>
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="home-dash__empty">
                <Icon icon="mdi:check-circle-outline" />
                <p>No pending reservation requests right now.</p>
              </div>
            )}
          </section>

          <section className="home-dash__panel">
            <div className="home-dash__panel-head">
              <div>
                <h2 className="home-dash__panel-title">Upcoming holidays</h2>
                <p className="home-dash__panel-desc">
                  Closures that affect table availability
                </p>
              </div>
              <Link to="/reservation-settings" className="home-dash__link">
                Manage
                <Icon icon="mdi:arrow-right" />
              </Link>
            </div>

            {holidayPreview.length > 0 ? (
              <div className="home-dash__table-wrap">
                <table className="home-dash__table">
                  <thead>
                    <tr>
                      <th>Start</th>
                      <th>End</th>
                      <th>Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    {holidayPreview.map((exc, index) => (
                      <tr key={exc?.id ?? index}>
                        <td>
                          {exc?.startTime
                            ? Utils.parseAndFormat2(exc.startTime)
                            : "N/A"}
                        </td>
                        <td>
                          {exc?.endTime
                            ? Utils.parseAndFormat2(exc.endTime)
                            : "N/A"}
                        </td>
                        <td>{exc?.reason || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="home-dash__empty">
                <Icon icon="mdi:beach" />
                <p>No upcoming holidays are listed.</p>
              </div>
            )}
          </section>
        </div>
      </div>
    </MasterLayout>
  );
};

export default HomePageOne;
